import Layout from '@/components/Layout/Vanilla';
import Button from '@/components/Button';
import Hero from '@/components/Hero';
import IconContentBlock from '@/components/IconContentBlock';
import IndustryList from '@/components/IndustryList';
import ContentBlock from '@/components/ContentBlock';
import SectionHero from '@/components/SectionHero';
import APIShowcase from '@/components/APIShowcase';
import Section from '@/components/Section';
import { fetchPage, gql } from '@/lib/graphcms';

export default function GraphQL({ page }) {
  const { usps, contentBlocks } = page;

  return (
    <Layout seo={page}>
      <Section>
        <Hero {...page}>
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Build your own content API &#8594;
          </Button>
        </Hero>
        <div className="md:flex md:flex-wrap -mx-6">
          {usps.map(IconContentBlock)}
        </div>
      </Section>
      <Section colour="light">
        <SectionHero noHr title="Why GraphQL" />
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>
      <Section container="narrow">
        <SectionHero noHr title="GraphQL by Example" />

        <APIShowcase />
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { page } =
    (await fetchPage(
      gql`
        query aboutUsPageQuery {
          page(where: { slug: "graphql" }) {
            ...pageData # Fragment is inside the method
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  return {
    props: {
      preview,
      page,
    },
    revalidate: 3600,
  };
};
